import React, { Component } from "react";

export default class Menu7 extends Component {
  render() {
    console.log("test p7");
    return <></>;
  }
}
